import React from "react";

import LoadingSVG from "../assets/img/loader.svg";

function LoadingOverlay(props) {
    let {visible} = props;
    return <div className="loading-overlay" style={{display: visible ? "flex" : "none"}}><img src={LoadingSVG} alt="Loading" /></div>;
}

export default LoadingOverlay;